module.exports = __webpack_public_path__ + "static/compadre-dd427037b9c3f9ce3a070ea9258915d3.gif";